import React, { Fragment } from 'react'
import Configuration from '../utils/configuration';

var pathinfo = require('pathinfo');

export default function PartDownloads(props) {
    let part = props.part;
    return (
        <Fragment>
            <div className="text">
                <div dangerouslySetInnerHTML={{__html: part['content']}} />
            </div>
            <div className="flex column">
                {
                    part['media']['downloads'] && part['media']['downloads'].map(download => {
                        if(download['path']) {
                            let pathinfo = pathinfo(download['path']);
                            let file_name = download['title'] !== ''? download['title']: pathinfo['basename'];
                            return (
                                <div className="item">
                                    <a className="download flex items-center" href={download['path']} target="_blank" rel="noopener noreferrer">
                                        <span className="icon">
                                            <img src={`${Configuration.RESOURCES_URL}img/style/descargas.svg`} alt="Icono descarga" />
                                        </span>
                                        <span className="item name">{file_name}</span>
                                    </a>
                                </div>
                            )
                        } else {
                            return null
                        }
                    })
                }
            </div>
        </Fragment>

    )
}



